import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const links = [
  { to: "/care-portal", label: "Home", end: true },
  { to: "/care-portal/start-here", label: "Start Here" },
  { to: "/care-portal/callachap", label: "CALLACHAP" },
  { to: "/care-portal/on-demand", label: "On Demand" },
  { to: "/care-portal/resources", label: "Resource Library" },
  { to: "/care-portal/request-support", label: "Request Support" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-slate-200" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/care-portal" className="flex items-center gap-3 group" data-testid="navbar-logo" aria-label="California Corporate Chaplains — Care Portal home">
          <img
            src="/ccchaps-logo.png"
            alt="California Corporate Chaplains"
            className="h-10 w-10 sm:h-11 sm:w-11 object-contain shrink-0"
          />
          <span className="hidden sm:block h-7 w-px bg-slate-200" aria-hidden="true" />
          <span className="font-heading text-sm sm:text-base font-medium text-slate-700 tracking-tight">
            Care Portal
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-link-${l.to.replace(/\//g, "") || "home"}`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                  isActive
                    ? "text-[#4A6FA5] bg-[#F0F4F8]"
                    : "text-slate-600 hover:text-slate-900 hover:bg-slate-50"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-md text-slate-700 hover:bg-slate-100"
          onClick={() => setOpen(!open)}
          data-testid="navbar-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white" data-testid="navbar-mobile-menu">
          <div className="px-4 py-3 space-y-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `block px-3 py-2.5 rounded-md text-sm font-medium ${
                    isActive ? "text-[#4A6FA5] bg-[#F0F4F8]" : "text-slate-700 hover:bg-slate-50"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
